interface IsSocureSessionAssociationErrorParams {
  message: string
}

/**
 * The Socure device-risk SDK logs this exact message via `console.error` (which RUM captures as a
 * `source:console` error) and then throws, whenever its `/customer-session` association POST is
 * rejected. The rejection is an intermittent, non-blocking failure on a session token the SDK
 * manages internally — `addSocureSession` recovers by re-keying the session and reports the
 * failure under its own message with diagnostic context — so the SDK's raw console error is
 * recoverable vendor noise, not an actionable fault.
 */
const SOCURE_SESSION_ASSOCIATION_ERROR_MESSAGE = 'Failed to associate customer session id'

export const isSocureSessionAssociationError = ({ message }: IsSocureSessionAssociationErrorParams): boolean =>
  message.includes(SOCURE_SESSION_ASSOCIATION_ERROR_MESSAGE)
